export default __webpack_public_path__ + "static/media/mobile-cropped-allconnect.c41b8756.png";